module.exports = __webpack_public_path__ + "static/img/xiangqing2.c556f7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiangqing2.png
// module id = HxLP
// module chunks = 24